// extracted by mini-css-extract-plugin
export var box = "_1m-2";
export var checkboxControl = "_1m-0";
export var checkboxRow = "_1m-a";
export var checked = "_1m-3";
export var descriptionSpacer = "_1m-c";
export var disabled = "_1m-4";
export var icon = "_1m-8";
export var input = "_1m-1";
export var labelSpacer = "_1m-b";
export var large = "_1m-7";
export var medium = "_1m-6";
export var small = "_1m-5";
export var text = "_1m-9";